import { EtiquetasService } from '../../_services/etiquetas.service';

export class Respuesta {
	Data: any;
	Succeed: boolean;
	Message: string;
	Code: number;

	constructor(params?) {
		if (params) {
			this.Data = params.Data;
			this.Succeed = params.Succeed;
			this.Message = params.Message;
			this.Code = params.Code;
		}
	}

	esErrorGUI() {
		return this.Message.includes('FlexGuiException');
	}

	obtenerMensajeGUI(service: EtiquetasService) {
		if (!this.Message) return null;
		if (!this.esErrorGUI()) return this.Message;

		try {
			let claveValor: string = this.Message.split('|')[1];
			if (!claveValor.includes(':')) return claveValor;
			let kvp: string[] = claveValor.split(':');
			return service.getEtiqueta(kvp[0], kvp[1]);
		} catch {
			return this.Message;
		}
	}
}

export class KnowRespuesta<T> {
	Data: T;
	Succeed: boolean;
	Message: string;
	Code: number;
}
